import { Fragment } from "react";
import './titolo.css'
import TemporaryDrawer from "./bottoni";


function Titolo() {
    return(<Fragment>
        <div style={{ color: "white" }}>
          <h1 id="titoloAzienda" style={{ display: "2" }}>
          Gomme usate Jossytony Tyres
          </h1>
          <br/>
          <br/>
          <br/>
          <br/>
         <TemporaryDrawer/>
        </div>
    </Fragment>)
}

export default Titolo